import { Injectable } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

export const RESULT_EXAMPLE = 'RES_example';
export const RESULT_REMITOS = 'RES_remitos';

/**
 * En esta clase vamos a almacenar los resultados de una busqueda y sus filtros en caso
 * de existir en formato JSON.stringify. El ID debe registrarse en la clase para poder
 * acceder a el de forma mas ordenada.
 * **/
@Injectable()
export class ResultsCacheService {

  private results: ResultsCache[] = [];

  constructor(
    private router: Router,
  ) {
    this.router.events.filter(event => event instanceof NavigationEnd)
      .subscribe((e:any) => {
        if (e.url && this.results.length) {
          this.results = this.results.filter(res => {
            // si no se agrega una URL, el resultado se mantendra mientras dure la sesion
            if (res.resultURLKeywords.length) {
              return res.resultURLKeywords.some(key => {
                return e.url.includes(key);
              })
            }
            return true; // si no tiene keywords se mantiene
          });
        }
      });
  }

  public get getCacheData() {
    return this.results;
  }

  public clearAllData() {
    this.results = [];
  }

  public clearData(id: string) {
    this.results = this.results.filter(x => x.resultId !== id);
  }

  public getData(id: string): ResultsCache | undefined {
    return this.results.find(x => x.resultId === id);
  }

  public createOrUpdateData(id: string, data: ResultsCache) {
    const update = this.results.find(x => x.resultId === id);
    if (update) {
      update.resultJSON = data.resultJSON;
      update.resultFilter = data.resultFilter;
      update.resultURLKeywords = data.resultURLKeywords;
    } else {
      this.results.push(data)
    }
  }

}

export interface ResultsCache {
  resultId: string;
  resultJSON: string;
  resultFilter: string;
  resultURLKeywords: string[];
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/results-cache.service.ts